/** @jsx jsx */
import {jsx} from 'theme-ui'
import Layout from './Layout'
import Loader from './Loader'

type Props = {}

const FullScreenLoader: React.FC<Props> = () => {
  return (
    <Layout
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loader />
    </Layout>
  )
}

export default FullScreenLoader
